/**
 * /dashboard/accounting/purchases/new — Create bill (G_ACC5).
 *
 * Save Draft (POST /bills) or Save & Receive (POST /bills then
 * /bills/{id}/receive). Both routes are accounting-admin role-gated.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/purchases/new/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { BillForm } from "@/components/accounting/bill-form";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/purchases/new",
)({
  component: NewBillRoute,
});

function NewBillRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="New Bill"
      description="Record a vendor bill — draft now, receive to post to the journal."
    >
      <BillForm />
    </AccountingModuleShell>
  );
}
